// src/components/container/FolderNews.tsx

import { Container, Typography } from '@mui/material'
import DOMPurify from 'dompurify'

type Props = {
  news: any[]
}

export const FolderNews = ({ news }: Props) =>
  !news ? null : (
    <Container>
      {news.map(item => {
        const { content_text, headline, title } = item.attributes

        return (
          <Container key={title}>
            <Typography>{headline}</Typography>

            <Typography>{title}</Typography>

            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content_text),
              }}
            />
          </Container>
        )
      })}
    </Container>
  )
